export default __webpack_public_path__ + "1f10b8a299f8185c0b848d8de47aa5d4.svg";